<template>
  <!-- editProviderModal -->
  <div
    id="editProviderModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editProviderModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <form class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">
            {{ $t("label.affiliate.detail.addProvider.editProvider") }} : {{ providerId }}
          </h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          />
        </div>
        <div class="modal-body">
          <div
            v-if="isModalProcessing"
            class="text-center"
          >
            <img
              src="@/assets/img/loader.gif"
              class="center-block"
            >
          </div>
          <div v-else>
            <div
              v-if="modalError"
              class="col"
            >
              <div
                class="
                  alert alert-danger
                  text-center
                  border-0
                  shadow-sm
                  rounded-0
                "
              >
                {{ $t("error." + `${modalResponseErr}`) }}
              </div>
            </div>

            <div class="col">
              <label class="control-label fw-bold mb-1">
                {{ $t("label.affiliate.detail.addProvider.connectionMode") }} *
                <span
                  :title="
                    $t('label.affiliate.detail.addProvider.connectionModeInfo')
                  "
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <select
                v-model="criterias.connectionMode"
                :class="status(v$.criterias.connectionMode)"
                name="connectionMode"
                class="form-control rounded-0 form-select"
                :data-placeholder="
                  $t('label.affiliate.detail.addProvider.connectionMode')
                "
              >
                <option
                  v-for="type in connectionModeEnum"
                  :key="type.id"
                  :value="type"
                >
                  {{ type }}
                </option>
              </select>
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="!v$.criterias.connectionMode.required">{{
                  $t("error.VALIDATION_MANDATORY_CRITERIA")
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            id="closeEditProviderModal"
            type="button"
            class="btn btn-default"
            data-bs-dismiss="modal"
          >
            {{ $t("button.cancel") }}
          </button>
          <BaseButton
            type="button"
            class="btn btn-primary"
            @click-base-button-event-emitter="editProvider()"
          >
            {{ $t("button.save") }}
          </BaseButton>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import BaseButton from '@/components/BaseButton'
import { ConnectionMode } from '@/enums/connection-mode.enum'
import { Modal } from 'bootstrap';
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  components: {
    BaseButton
  },
  props: {
    affiliateDetail: {
      type: Object,
      required: true
    }
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      criterias: {
        connectionMode: ''
      },
      providerId: '',
      isModalProcessing: false,
      modalError: false,
      validationError: false,
      connectionModeEnum: ConnectionMode
    }
  },
  created () {
  },

  methods: {
    show (provider) {
      this.isModalProcessing = false
      this.modalError = false
      this.providerId = provider.providerId
      this.criterias.connectionMode = provider.connectionMode
      let editProviderModal = new Modal(document.getElementById('editProviderModal'))
      editProviderModal.show()
    },
    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },
    editProvider () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.runUpdateProvider()
      }
    },
    async runUpdateProvider () {
      this.isModalProcessing = true
      this.modalResponseErr = null

      await this.$store.dispatch('affiliates/updateProvider', {
        contractId: this.affiliateDetail.contractId,
        distributorRef: this.affiliateDetail.distributorId,
        commercialProduct: this.affiliateDetail.productId,
        providerId: this.providerId,
        affiliateEditMode: true,
        connectionMode: this.criterias.connectionMode
      }).then(
        () => {
          this.isModalProcessing = false
          this.modalError = false
          document.getElementById('closeEditProviderModal').click()
        },
        error => {
          this.isModalProcessing = false
          this.modalError = true
          this.modalResponseErr = error.data.errorCode
        }
      )
    }
  },

  validations() {
    return {
      criterias: {
        connectionMode: { required }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.error {
  color: red;
}

.validation-error {
  border-color: red;
  background: #FDD;

  &:focus {
    outline-color: rgb(250, 28, 28);
  }
}

</style>
